<template>
  <v-dialog v-model="dialog" width="500" class="dialogClass">
    <v-card style="border-bottom: 8px solid #ffc627; text-align: center; background-color: white">
      <div v-if="show === 'confetti'" style="height: 80px" />
      <div v-if="show === 'pathway' || show === 'courseCompletion'" style="height: 40px" />
      <v-col cols="12" class="confettiTitle">Congratulations!</v-col>

      <v-col v-if="show === 'confetti'" cols="12" style="font-size: 16px; font-weight: bold; margin: 12px">{{
        celebrateEventMessage
      }}</v-col>

      <v-col v-if="show === 'pathway'" cols="12" class="my-4 font-weight-bold">You completed your Pathway!</v-col>
      <div v-if="show === 'confetti'" style="height: 20px" />
      <v-row justify="center" v-if="show === 'pathway'">
        <v-col xl="9" lg="9" md="10" sm="10" cols="10">
          Please ensure you have submitted an application to ASU and contact the Student Support team for the next steps
          at
          <a style="color: #8c1d40" href="mailto:pathwaysfuture@asu.edu">pathwaysfuture@asu.edu</a>
          or 844-448-7707.</v-col
        >
      </v-row>

      <v-row justify="center" v-if="show === 'courseCompletion' && completedCoursesForConfetti.length > 0" class="mt-4">
        <v-col xl="9" lg="9" md="10" sm="10" cols="10">
          Congratulations! You completed
          <span v-html="getCompletedCoursePrefixes()" />
          <br />
          Don’t forget to add this course to your transcript if you would like to receive academic credit.
        </v-col>
      </v-row>

      <div v-if="show === 'pathway' || show === 'courseCompletion'" style="height: 30px" />
      <v-col cols="12" sm="6" class="closeDialog" :class="show === 'courseCompletion' ? 'mb-3' : ''">
        <v-btn style="background-color: #fec627; color: black; z-index: 999; border-radius: 10px" @click="closeDialog()"
          >Close</v-btn
        >
      </v-col>
      <div v-if="show === 'confetti'" style="height: 30px" />
    </v-card>
    <canvas v-if="showCanvasElement" id="canvas" class="canvasClass" />
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['closeConfettiDialog', 'closePathwaysConfettiDialog', 'closeCourseCompletionConfettiDialog'],

  name: 'CompletionModal',

  data() {
    return {
      dialog: true
      // dialog: false
    };
  },

  methods: {
    closeDialog() {
      if (this.show === 'confetti') {
        this.$emit('closeConfettiDialog');
      } else if (this.show === 'pathway') {
        this.$emit('closePathwaysConfettiDialog');
      } else if (this.show === 'courseCompletion') {
        this.$emit('closeCourseCompletionConfettiDialog');
      }
      this.dialog = !this.dialog;
    },

    getCompletedCoursePrefixes() {
      if (this.completedCoursesForConfetti.length > 1) {
        let coursePrefixes = this.completedCoursesForConfetti.map(
          (e) =>
            // Added font-weight explicitly because font-weight: bolder wasn't working
            `<strong style="font-weight: 900">${e._courseInfo._coursePrefixDisplayLabel}</strong>`
        );
        const lastPrefix = coursePrefixes.pop();
        return coursePrefixes.join(', ') + ' and ' + lastPrefix + '.';
      } else if (this.completedCoursesForConfetti.length === 1) {
        return `<strong style="font-weight: 900">${this.completedCoursesForConfetti[0]._courseInfo._coursePrefixDisplayLabel}</strong>`;
      }
    }
  },

  props: {
    show: String,
    celebrateEventMessage: String,
    showCanvasElement: Boolean,
    completedCoursesForConfetti: Array
  }
});
</script>

<style lang="stylus">
.dialogClass {
  width: 100%;
  height: 210px;
}

.confettiTitle {
  font-weight: bold;
  font-size: 42px;
  color: #191919;
  line-height: 2rem !important;

  @media (max-width: 300px) {
    font-size: 30px;
  }

  @media (min-width: 320px) and (max-width: 500px) {
    font-size: 34px;
  }
}

.closeDialog {
  margin-left: 330px;

  @media (max-width: 300px) {
    margin-left: 100px;
  }

  @media (min-width: 320px) and (max-width: 370px) {
    margin-left: 145px;
  }

  @media (min-width: 371px) and (max-width: 500px) {
    margin-left: 210px;
  }
}

.canvasClass {
  position: absolute;
  top: 0;
  left: 0;
}

#canvas {
  height: 100%;
  width: 100%;
}
</style>
